import { Link } from "react-router-dom";
import { ArrowRight, Megaphone, Globe, Database, Sparkles, Mail } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Reveal from "./Reveal";

const icons = [Megaphone, Globe, Database, Sparkles, Mail];

export default function ServiceCards() {
  const { t, link } = useLang();
  const cards = t("services.cards");
  return (
    <section data-testid="services-section" className="bg-mist text-ink py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.25em] text-dblue">{t("services.eyebrow")}</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl">{t("services.title")}</h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 max-w-2xl leading-relaxed">{t("services.sub")}</p>
        </Reveal>
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-6">
          {cards.map((c, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={c.num} delay={i * 0.08} className={i < 3 ? "lg:col-span-2" : "lg:col-span-3"}>
                <Link
                  to={link(c.to)}
                  data-testid={`service-card-${c.to.slice(1)}`}
                  className="group flex h-full flex-col rounded-2xl border border-ink/10 bg-white p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-dblue/40 hover:shadow-[0_20px_50px_-20px_rgba(20,110,245,0.35)]"
                >
                  <div className="flex items-center justify-between">
                    <span className="font-display text-xs font-bold tracking-[0.2em] text-dblue">{c.num}</span>
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-mist text-ink transition-colors duration-300 group-hover:bg-gradient-to-br group-hover:from-dblue group-hover:to-electric group-hover:text-white">
                      <Icon className="h-5 w-5" />
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-lg font-bold tracking-tight">{c.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed flex-1">{c.desc}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-dblue">
                    <span className="h-px w-6 bg-dblue transition-all duration-300 group-hover:w-9" />
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
